// OS MODELOS DE PDF DA MAESTRA: o banco de três desenhos que a pessoa escolhe ao exportar um
// documento (o branding, o diagnóstico). O que muda entre eles é o papel (claro ou escuro), a
// tipografia e a capa; o conteúdo é o mesmo. O último escolhido fica guardado no navegador, por
// documento (é preferência de quem exporta, não dado do perfil).

export const MODELOS_DO_PDF = ['classico', 'noite', 'revista'] as const;
export type ModeloDoPdf = typeof MODELOS_DO_PDF[number];

export const MODELO_PADRAO: ModeloDoPdf = 'classico';

/** Os documentos que têm banco de modelos (a chave guardada é por documento). */
export type DocumentoComModelos = 'branding' | 'diagnostico' | 'presskit';

const chaveDe = (documento: DocumentoComModelos) => `maestra.${documento}.modeloDoPdf`;

const eModelo = (v: unknown): v is ModeloDoPdf => typeof v === 'string' && (MODELOS_DO_PDF as readonly string[]).includes(v);

export const lerModeloGuardado = (documento: DocumentoComModelos): ModeloDoPdf => {
  try {
    const v = window.localStorage.getItem(chaveDe(documento));
    return eModelo(v) ? v : MODELO_PADRAO;
  } catch { return MODELO_PADRAO; }
};

export const guardarModelo = (documento: DocumentoComModelos, m: ModeloDoPdf): void => {
  try { window.localStorage.setItem(chaveDe(documento), m); } catch { /* sem armazenamento, sem memória: o padrão volta */ }
};

/** O tema do Carbon em que cada modelo é desenhado: o Noite é o único de papel escuro. */
export const temaDoModelo = (m: ModeloDoPdf): 'white' | 'g100' => (m === 'noite' ? 'g100' : 'white');
